import { render, staticRenderFns } from "./IconSvgClipboardList.vue?vue&type=template&id=637f02dd&"
import script from "./IconSvgClipboardList.vue?vue&type=script&lang=js&"
export * from "./IconSvgClipboardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports